/** @jsx jsx */
import { jsx, css } from '@emotion/react';
var titleStyles = css({
  padding: "2px 0 6px 16px",
  flex: 1,
  fontWeight: 600
});

var Title = function Title(_ref) {
  var color = _ref.color,
      children = _ref.children;
  return jsx("span", {
    style: {
      color: color
    },
    css: titleStyles
  }, children);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc


export default Title;